var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinFlat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 88,
    viewBox: "0 0 16 22",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F45757"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 10,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 12,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 2,
    height: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 6,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 4,
    height: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFlat);
export default __webpack_public_path__ + "static/media/pin-flat.29f8ccc2a250ce67a7788878f62af18d.svg";
export { ForwardRef as ReactComponent };